import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Col, Row, Button, Table } from '_zari/core'

import * as TablaComunService from 'services/tablasComunes.service'

import { IdGen } from 'utils'

import * as Sections from './sections'

const CrudPlantillasModal = ({ show, handleClose, tipo }) => {
  const __zariContext = React.useContext(ZariContext)

  const [sectionKey, setSectionKey] = React.useState(IdGen.newId())
  const [plantillas, setPlantillas] = React.useState([])

  const edicionDataRef = React.useRef({})

  const actualizarPlantillas = React.useCallback(() => {
    TablaComunService.obtenerxTipoAsSlim(tipo)
      .then(({ data }) => {
        if (data) {
          setPlantillas(data || [])
        }
      })
      .catch(() => {
        setPlantillas([])
      })
  }, [tipo])

  React.useEffect(() => {
    actualizarPlantillas()
  }, [actualizarPlantillas])

  const clickEditar = React.useCallback(
    id => {
      TablaComunService.getAsEdicion(id)
        .then(({ data }) => {
          edicionDataRef.current = data
          setSectionKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    id => {
      TablaComunService.eliminarxId(id)
        .then(() => {
          setSectionKey(IdGen.newId())
          actualizarPlantillas()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, actualizarPlantillas]
  )

  const refrescarSection = React.useCallback(() => {
    edicionDataRef.current = {}
    setSectionKey(IdGen.newId())
  }, [])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Control Plantillas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Table
              filas={plantillas}
              maxRowsShown={10}
              headRows={[
                {
                  label: 'Código'
                },
                {
                  label: 'Nombre'
                },
                {
                  label: ''
                }
              ]}
              rowTemplate={row => (
                <Table.Row key={row._id}>
                  <Table.Cell>{row.codigo || '--'}</Table.Cell>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item
                          key='editar-plantilla'
                          handleClose={handleClose}
                          onClick={() => clickEditar(row._id)}
                        >
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='eliminar-plantilla'
                          handleClose={handleClose}
                          onClick={() => clickEliminar(row._id)}
                        >
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6}>
            <Sections.CrearEditarPlantillaSection
              key={sectionKey}
              editarData={edicionDataRef.current}
              refrescarSection={refrescarSection}
              refrescarTabla={actualizarPlantillas}
              tipo={tipo}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CrudPlantillasModal)
